// usePosts.js
import { useQuery } from "@tanstack/react-query";
import { supabase } from "../services/supabase";

// Function to fetch posts only from Supabase
const fetchPosts = async () => {
  try {
    const { data, error } = await supabase
      .from("posts")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.warn("Supabase error:", error.message);
      return [];
    }
    if (!data || data.length === 0) {
      return [];
    }
    return data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    return [];
  }
};

// Custom Hook to use TanStack Query for fetching posts
export const usePosts = () => {
  return useQuery({
    queryKey: ["posts"],
    queryFn: fetchPosts,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    retry: 1, // Only retry once
    retryDelay: 1000, // Wait 1 second before retry
  });
};
